import http from '../http-common'

class ConfigService {
  async getEnv() {
    const response = await http.get(`/config/env`)
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async getMaintenance() {
    const response = await http.get(`/config/maintenance`)
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async setWhitelist(code) {
    const response = await http.post(`/config/whitelist`, { code: code })
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }
}

export default new ConfigService()
